import { h } from "preact";

import style from './style';

const MainImage = ({ src, alt = "Literatuur en Geneeskunde" }) => (
  <div class={style["main-image"]}>
    <img src={src} class={style["main-image-img"]} alt={alt} />
  </div>
);

export default MainImage;
